module.exports = __webpack_public_path__ + "static/Legalization_Header-2d775c5bb3f63b7ee936b413401f91fa.svg";